'use client';

import { useOthers, useSelf } from '@liveblocks/react';
import { Avatar, Inline, Typography } from '@org/design-system';
import { useCollaborationIdentity } from './PresenceProvider';
import type { CollaborationPresence } from './presence';

function ActiveUsersTopbarInner() {
  const self = useSelf();
  const others = useOthers();
  const users = [
    ...(self ? [{
      id: `self-${self.connectionId}`,
      isSelf: true,
      presence: self.presence as CollaborationPresence,
    }] : []),
    ...others.map((other) => ({
      id: String(other.connectionId),
      isSelf: false,
      presence: other.presence as CollaborationPresence,
    })),
  ];

  return (
    <Inline gap={2} className="justify-end">
      <Typography variant="small" color="muted">Active now</Typography>
      <Inline gap={1}>
        {users.map((user) => (
          <Avatar
            key={user.id}
            size="sm"
            fallback={(user.presence.name ?? 'U').slice(0, 2).toUpperCase()}
            style={{ backgroundColor: user.presence.color ?? 'var(--ds-color-surface-accent)' }}
            title={`${user.presence.name ?? 'Collaborator'}${user.isSelf ? ' (you)' : ''}`}
          />
        ))}
      </Inline>
    </Inline>
  );
}

export function ActiveUsersTopbar() {
  const { enabled } = useCollaborationIdentity();
  if (!enabled) return null;
  return <ActiveUsersTopbarInner />;
}
